// types
import { DefaultConfigProps } from "types/config";

// ==============================|| THEME CONSTANT ||============================== //

export const twitterColor = "#1DA1F2";
export const facebookColor = "#3b5998";
export const linkedInColor = "#0e76a8";

export const APP_DEFAULT_PATH = "/dashboard";
export const API_KEY_maptiler =
  import.meta.env.VITE_MAPTILER_KEY || "th9XtGmGbB2SSaldyQ7E";
export const apiBaseUrl = (
  import.meta.env.VITE_BACKEND_URL || "http://localhost:8008"
).replace(/\/$/, "");
export const HORIZONTAL_MAX_ITEM = 7;
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;

export enum SimpleLayoutType {
  SIMPLE = "simple",
  LANDING = "landing",
}

export enum ThemeMode {
  LIGHT = "light",
  DARK = "dark",
}

export enum MenuOrientation {
  VERTICAL = "vertical",
  HORIZONTAL = "horizontal",
}

export enum ThemeDirection {
  LTR = "ltr",
  RTL = "rtl",
}

export enum NavActionType {
  FUNCTION = "function",
  LINK = "link",
}

export enum Gender {
  MALE = "Male",
  FEMALE = "Female",
}

export enum DropzoneType {
  DEFAULT = "default",
  STANDARD = "standard",
}

export enum AuthProvider {
  JWT = "jwt",
  FIREBASE = "firebase",
  AUTH0 = "auth0",
  AWS = "aws",
  SUPABASE = "supabase",
}

export const APP_AUTH: AuthProvider = AuthProvider.JWT;

// ==============================|| THEME CONFIG ||============================== //

const config: DefaultConfigProps = {
  fontFamily: `'Public Sans', sans-serif`,
  i18n: "en",
  menuOrientation: MenuOrientation.VERTICAL,
  miniDrawer: false,
  container: true,
  mode: ThemeMode.LIGHT,
  presetColor: "default",
  themeDirection: ThemeDirection.LTR,
};

export default config;
